module.exports = __webpack_public_path__ + "img/ssl.c79a4247.webp";